const sheet = new CSSStyleSheet();
sheet.replaceSync(`
    :host {
        display: block;
        position: relative;
    }
    
    .lock-wrapper {
        position: relative;
        display: inline-block;
        width: 100%;
    }
    
    .locked-content {
        opacity: 0.6;
        pointer-events: none;
        user-select: none;
        transition: opacity 0.2s ease;
    }
    
    .overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 10;
        cursor: pointer;
    }
    
    .badge-container {
        position: absolute;
        top: -10px;
        right: -10px;
        z-index: 20;
        pointer-events: none;
    }
    
    .lock-badge {
        display: inline-flex;
        align-items: center;
        gap: 0.25rem;
        padding: 0.125rem 0.5rem;
        font-size: 0.75rem;
        font-weight: 600;
        border-radius: 9999px;
        box-shadow: 0 1px 2px rgba(0,0,0,0.05);
        border: 1px solid transparent;
        white-space: nowrap;
        text-transform: lowercase;
    }
    
    .level-pro {
        background-color: var(--color-green-100, #dcfce7);
        color: var(--color-green-700, #15803d);
        border-color: var(--color-green-200, #bbf7d0);
    }
    
    .level-plus {
        background-color: var(--color-blue-100, #dbeafe);
        color: var(--color-blue-700, #1d4ed8);
        border-color: var(--color-blue-200, #bfdbfe);
    }

    .level-credits {
        background-color: var(--color-yellow-100, #fef9c3);
        color: var(--color-yellow-700, #a16207);
        border-color: var(--color-yellow-200, #fef08a);
    }
    
    /* Para cuando el badge se muestra junto al label si se define como 'inline' */
    :host([inline]) .lock-wrapper {
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
    }
    
    :host([inline]) .badge-container {
        position: relative;
        top: 0;
        right: 0;
    }

    /* Para cuando necesitamos que el contenedor se ajuste al contenido (ej. botones) */
    :host([inline-block]) {
        display: inline-block;
    }
    
    :host([inline-block]) .lock-wrapper {
        width: auto;
    }
`);

export default sheet;
